import { toggleSnippet } from "../swiper_stories/swiper_stories.js";

// Het snippet op een videokaart speelt alleen zolang de muis of de focus erop staat. De kaarten komen via AJAX binnen, dus de luisteraars hangen aan de layout en niet aan de kaarten.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
	document.querySelectorAll(".grid_stories-layout").forEach((layout) => {
		layout.addEventListener("pointerenter", (event) => toggleSnippet(event.target, true), true);
		layout.addEventListener("pointerleave", (event) => toggleSnippet(event.target, false), true);
		layout.addEventListener("focusin", (event) => toggleSnippet(event.target, true));
		layout.addEventListener("focusout", (event) => toggleSnippet(event.target, false));
	});
}
